const pageScrollSaver = {
    mounted () {
        setTimeout(() => {
            this.restoreScroll(true);
        }, 300);
    },
    methods: {
        onScroll (e) {
            const { page } = this.$store.state.pages;
            const uuid = page.uuid || page.to;
            if (e.target) {
                sessionStorage.setItem(`scroll-source-${uuid}`, 'div');
                sessionStorage.setItem(`scroll-target-id-${uuid}`, e.target.id);
                sessionStorage.setItem(`scroll-target-scrollTop-${uuid}`, e.target.scrollTop);
            } else if (e.verticalPosition) {
                sessionStorage.setItem(`scroll-source-${uuid}`, 'scrollArea');
                sessionStorage.setItem(`scroll-verticalPosition-${uuid}`, e.verticalPosition);
            }
        },
        restoreScroll (allowRecursionCall = true, p = undefined) {
            const { page } = this.$store.state.pages;
            if (!p) {
                p = page;
            }
            if (this.loading) {
                setTimeout(() => {
                    this.restoreScroll(true);
                }, 300);
                return;
            }
            const uuid = p.uuid || p.to;

            const source = sessionStorage.getItem(`scroll-source-${uuid}`);
            if (!source) {
                if (allowRecursionCall) {
                    setTimeout(() => {
                        this.restoreScroll(false);
                    }, 500);
                }
                return;
            }
            if (source === 'scrollArea') {
                if (this.$refs.scrollArea) {
                    const verticalPosition = sessionStorage.getItem(`scroll-verticalPosition-${uuid}`);
                    this.$refs.scrollArea.setScrollPosition('vertical', verticalPosition);
                } else
                if (allowRecursionCall) {
                    setTimeout(() => {
                        this.restoreScroll(false);
                    }, 300);
                }
            }
            if (source === 'div') {
                const scrollTop = sessionStorage.getItem(`scroll-target-scrollTop-${uuid}`);
                if (this.$refs.pageMainDiv) {
                    if (this.$refs.pageMainDiv.scrollTop !== scrollTop) {
                        this.$refs.pageMainDiv.scrollTop = scrollTop;
                        setTimeout(() => {
                            this.$refs.pageMainDiv.scrollTop = scrollTop;
                        }, 300);
                    }
                } else {
                    setTimeout(() => {
                        this.restoreScroll(false);
                    }, 300);
                }
            }
        },
    },
};

export default pageScrollSaver;
